import { GET, POST } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchApprovalRequests = () =>
  GET("approvals").pipe(map((response: any) => response));

export const fetchPaginatedApprovalsService = (payload: any) => {
  const { body, sortBy } = payload;
  return POST(
    `approvals${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const fetchApprovalApprove = (request: any) =>
  POST("approve", request).pipe(map((response: any) => response));

export const fetchApprovalReject = (request: any) =>
  POST("reject", request).pipe(map((response: any) => response));

export const fetchApprovalDetail = (id: string) =>
  GET(`request/${id}/details`).pipe(map((response: any) => response));
